import React from 'react';
import I18n from 'i18n-js';

import FormGroupWithInput from '@reverbdotcom/commons/src/components/form_group_with_input';

import { core_apimessages_ShippingLabelPackage } from '@reverbdotcom/commons/src/gql/graphql';
import bind from '@reverbdotcom/commons/src/bind';

interface IProps {
  inputName: string;
  fieldName: string;
  titleKey: string;
  subtitleKey?: string;
  measurementUnit: string;
  value: string;
  onUpdate(attributes: core_apimessages_ShippingLabelPackage);
  shippingPackage: core_apimessages_ShippingLabelPackage;
  roundUpUserInput?: boolean;
  disabled?: boolean;
}

export default class PackageInput extends React.Component<IProps> {
  @bind
  buildPackageDimensionAttributes(inputAttributes): Partial<core_apimessages_ShippingLabelPackage> {
    const dimensionAttributes = {
      value: inputAttributes[this.props.fieldName],
      unit: this.props.measurementUnit,
    };
    const packageAttributes = {};
    packageAttributes[this.props.fieldName] = dimensionAttributes;
    return packageAttributes;
  }

  @bind
  updateShippingPackageDimensions(attributes) {
    const packageAttributes = this.buildPackageDimensionAttributes(attributes);

    this.props.onUpdate(
      {
        ...this.props.shippingPackage,
        ...packageAttributes,
      },
    );
  }

  getSubtitle() {
    if (!this.props.subtitleKey) return;

    return I18n.t(`discovery.dashboard.selling.shippingLabels.package.${this.props.subtitleKey}`);
  }

  @bind
  roundValue(event) {
    const targetValue = event.target.value;
    const attributes = { [this.props.fieldName]: Math.ceil(targetValue).toString() };

    this.updateShippingPackageDimensions(attributes);
  }

  render() {
    return (
      <FormGroupWithInput
        onBlur={this.props.roundUpUserInput ? this.roundValue : null}
        label={I18n.t(`discovery.dashboard.selling.shippingLabels.package.${this.props.titleKey}`)}
        helpText={this.getSubtitle()}
        numberOnly
        required
        tagRequired
        value={this.props.value}
        inputName={this.props.inputName}
        fieldName={this.props.fieldName}
        updateField={this.updateShippingPackageDimensions}
        currencySuffix={this.props.measurementUnit}
        disabled={this.props.disabled}
        inputMode="decimal"
      />
    );
  }
}
